import { Component, Input } from '@angular/core';

/** A one-shot autofocus ring, positioned by percentage over a camera preview. */
@Component({
  selector: 'app-focus-ring',
  template: `<span
    *ngIf="point"
    class="focus-ring"
    aria-hidden="true"
    [style.left.%]="point.xPct"
    [style.top.%]="point.yPct"
  ></span>`,
  styleUrls: ['./focus-ring.component.scss'],
})
export class FocusRingComponent {
  @Input() point: { xPct: number; yPct: number } | null = null;
}
